// Human-in-the-loop approval decisions. A destructive/supervised tool call
// parks its Temporal workflow on a signal and renders an approval card; this
// call files the decision against the ApprovalRecord, which signals the
// workflow to resume (execute or skip the tool).

import { callAgentForge } from './http';

export const decideApproval = async (
  recordId: string,
  approved: boolean,
  note?: string
): Promise<void> => {
  await callAgentForge({
    method: 'POST',
    url: `/approvals/${recordId}/decide`,
    body: { approved, note: note ?? '' },
  });
};
